<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" @click="addUsageClick">添加使用方法</el-button>
        </el-form-item>
        <!--        <el-form-item label="技术名称">-->
        <!--          <el-input size="small" v-model="searchForm.name" placeholder="请输入技术名称"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item>-->
        <!--          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>-->
        <!--        </el-form-item>-->
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="cropTypeName" label="作物分类">
          </el-table-column>
          <el-table-column prop="cropName" label="作物"></el-table-column>
          <el-table-column prop="diseaseName" label="防治对象">
          </el-table-column>
          <el-table-column prop="formulationDosage" label="制剂和用药量">
          </el-table-column>
          <el-table-column prop="useMethod" label="使用方法">
          </el-table-column>
          <!--          <el-table-column prop="isPicture" label="图片" width="100">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.isPicture==0">没有</span>-->
          <!--              <span v-else>有</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="sort" label="排序" width="100"></el-table-column>-->
          <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">
                编辑
              </el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加使用方法" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-press-escape="false"
               top="5vh">
      <div style="display: block">
        <el-form size="mini" label-position="left" ref="editform" :model="editform" label-width="100px">
          <el-form-item label="商品名称:">
            <p>{{ editform.productName }}</p>
          </el-form-item>
          <el-form-item prop="cropDiseaseList" label="作物病害:"
                        :rules="[{ required: true, message: '请选择作物病害' }]">
            <el-cascader :options="options" style="width: 460px"
                         :props="{ checkStrictly: true,value:'id',label:'name',children:'children' }"
                         v-model="editform.cropDiseaseList"
                         filterable
                         clearable></el-cascader>
          </el-form-item>
          <el-form-item prop="formulationDosage" label="制剂用药量:"
                        :rules="[{ required: true, message: '请填写制剂用药量' }]">
            <el-input v-model="editform.formulationDosage" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item prop="useMethod" label="使用方法:" :rules="[{ required: true, message: '请选择使用方法' }]">
            <el-select v-model="editform.useMethod" style="width: 460px">
              <el-option v-for="(item,index) in methodList" :value="item.value" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="应用图例：">-->
          <!--            <div class="draggable-list">-->
          <!--              <draggable class="wrapper" v-model="editform.imageList">-->
          <!--                <transition-group>-->
          <!--                  <div class="item" v-for="(item, index) in editform.imageList" :key="item + index">-->
          <!--                    <img v-img-url="item.filePath"/>-->
          <!--                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i-->
          <!--                      class="el-icon-close"></i></a>-->
          <!--                  </div>-->
          <!--                </transition-group>-->
          <!--              </draggable>-->
          <!--              <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </el-form-item>-->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addUsage">确 定</el-button>
      </div>

    </el-dialog>

    <!--    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">-->
    <!--      上传图片-->
    <!--    </Upload>-->
  </div>
</template>

<script>
import Upload from '@/components/file/Upload'
import draggable from 'vuedraggable'
import PorductApi from '@/api/product.js'
import CropApi from '@/api/crop.js'

export default {
  name: 'Usage',
  inject: ['form'],
  components: {
    draggable,
    Upload
  },
  data () {
    return {
      loading: true,
      methodList: [
        {
          id: 1,
          value: '喷雾'
        }, {
          id: 2,
          value: '滴灌'
        }, {
          id: 3,
          value: '冲施'
        }, {
          id: 4,
          value: '撒施'
        }, {
          id: 5,
          value: '穴施'
        }, {
          id: 6,
          value: '淋根'
        }, {
          id: 7,
          value: '飞防'
        }, {
          id: 8,
          value: '沟施'
        },
      ],
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*总条数*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        score: 0,
        name: ''
      },
      config: {},
      dialogVisible: false,
      isProductUpload: false,
      file_name: 'image',
      editform: {
        cropDiseaseList: [],
        productId: 0,
        formulationDosage: '',
        useMethod: '',
        imageList: [],
        productName: ''
      },
      options: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      /*获取列表*/
      this.getData()
      this.getCropOption()
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    getCropOption () {
      let self = this
      CropApi.cropList({}, true)
        .then(res => {
          self.options = res.data || []
        })
        .catch(error => {
        })

    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },
    getData () {
      let self = this
      self.loading = true
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.status = self.status
      if (this.form.model.productId) {
        Params.productId = this.form.model.productId
      }
      PorductApi.getUsageList(Params, true).then(res => {
        self.loading = false
        self.tableData = res.data.records
        self.totalDataNumber = res.data.total
      }).catch(error => {
        self.loading = false
      })
    },
    addUsageClick () {
      this.editform = {
        cropDiseaseList: [],
        formulationDosage: '',
        useMethod: '',
        imageList: [],
        productId: this.form.model.productId,
        productName: this.form.model.productName || '',
      }
      this.dialogVisible = true
    },
    dialogFormVisible (e) {
      this.editform = {
        cropDiseaseList: [],
        productId: 0,
        formulationDosage: '',
        useMethod: '',
        imageList: [],
        productName: ''
      }
    },
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      }
      this.isProductUpload = true
    },
    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.editform.imageList = this.editform.imageList.concat(e)
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.editform.imageList.splice(index, 1)
    },
    addUsage () {
      this.$refs.editform.validate((valid) => {
        if (valid) {
          let self = this
          let params = {}
          Object.assign(params, this.editform)
          let [cropTypeId, cropId, diseaseId] = this.editform.cropDiseaseList
          params.cropTypeId = cropTypeId || 0
          params.cropId = cropId || 0
          params.diseaseId = diseaseId || 0
          if (!params.cropTypeId) {
            return self.$message({
              message: '请选择作物病害',
              type: 'success'
            })
          }
          if (this.editform.id) {
            PorductApi.editProductUsage(params).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getData()
              self.dialogVisible = false
            })
          } else {
            PorductApi.addProductUsage(params).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getData()
              self.dialogVisible = false
            })
          }
        }
      })
    },
    editClick (row) {
      let usageId = row.id
      PorductApi.getUsageDetail({usageId}, true).then(res => {
        let data = res.data
        let cropDiseaseList = []
        let cropTypeId = data.cropTypeId || 0
        if (cropTypeId) {
          cropDiseaseList.push(cropTypeId)
          let cropId = data.cropId || 0
          if (cropId) {
            cropDiseaseList.push(cropId)
            let diseaseId = data.diseaseId || 0
            if (diseaseId) {
              cropDiseaseList.push(diseaseId)
            }
          }
        }
        this.editform = {
          id: data.id || 0,
          cropDiseaseList: cropDiseaseList,
          formulationDosage: data.formulationDosage || '',
          useMethod: data.useMethod || '',
          imageList: data.imageList || [],
          productId: this.form.model.productId,
          productName: this.form.model.productName || ''
        }
        this.dialogVisible = true
      }).catch(error => {
        console.log(error)
      })
    },
    delClick: function (row) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.delUsage({
          usageId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getData()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Usage.vue